import CircularProgress from 'material-ui/CircularProgress';
import moment from 'moment';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import {
    Entities,
    fetchById,
    getCurrencySymbol,
    getUpdatedEntity,
    patch,
    save,
    setMoneyCurrency,
    TOMCAT_URL,
} from 'src/common/index';
import { setSliderIndex } from 'src/actions/form';
import ErrorMessage from 'src/components/misc/error-message';
import SeasonCalculationEditForm from 'src/components/administration/season-calculation-edit-form';
import _ from 'lodash';
import { getOwnCompany } from 'src/selectors/bus-companies';
import { DayOfWeek } from 'src/utils/daysOfWeek';

class SeasonCalculationEditModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            startedFetching: false,
        };
    }

    componentWillMount() {
        const { isCreate, id, selectedCompany } = this.props;

        if (!isCreate) this.props.fetchById(id, Entities.SEASON_CALCULATION, selectedCompany);
        else this.setState({ startedFetching: true });
    }

    componentWillReceiveProps(nextProps) {
        const { seasonCalculation } = nextProps;

        if (seasonCalculation.isFetching && !this.state.startedFetching) this.setState({ startedFetching: true });
    }

    callSubmit() {
        return this.childForm.submit();
    }

    didFormChange() {
        return !this.childForm.pristine;
    }

    render() {
        const { seasonCalculation, selectedCompany, ownCompany, isCreate, t } = this.props;

        const finishFetching = this.state.startedFetching && !seasonCalculation.isFetching;
        const currencySymbol = getCurrencySymbol(ownCompany.entity.currency);

        if (finishFetching) {
            if (seasonCalculation.error) return <ErrorMessage object={seasonCalculation} />;
            else {
                let initialValues;
                if (!isCreate && seasonCalculation.content) {
                    initialValues = {
                        id: seasonCalculation.content.id,
                        name: seasonCalculation.content.name,
                        mondaySurcharge: seasonCalculation.content.mondaySurcharge,
                        tuesdaySurcharge: seasonCalculation.content.tuesdaySurcharge,
                        wednesdaySurcharge: seasonCalculation.content.wednesdaySurcharge,
                        thursdaySurcharge: seasonCalculation.content.thursdaySurcharge,
                        fridaySurcharge: seasonCalculation.content.fridaySurcharge,
                        saturdaySurcharge: seasonCalculation.content.saturdaySurcharge,
                        sundaySurcharge: seasonCalculation.content.sundaySurcharge,
                        mondayRate: seasonCalculation.content.mondayRate,
                        tuesdayRate: seasonCalculation.content.tuesdayRate,
                        wednesdayRate: seasonCalculation.content.wednesdayRate,
                        thursdayRate: seasonCalculation.content.thursdayRate,
                        fridayRate: seasonCalculation.content.fridayRate,
                        saturdayRate: seasonCalculation.content.saturdayRate,
                        sundayRate: seasonCalculation.content.sundayRate,
                        sundayDriverSurcharge: seasonCalculation.content.sundayDriverSurcharge,
                        holidayDriverSurcharge: seasonCalculation.content.holidayDriverSurcharge,
                        seasonSurcharges: this.formatSurchargesForForm(seasonCalculation.content.seasonSurcharges),
                        specialSurcharges: this.formatSurchargesForForm(seasonCalculation.content.specialSurcharges),
                        holidays: this.formatHolidaysForForm(seasonCalculation.content.holidays),
                        zones: seasonCalculation.content.zones,
                        zoneTimeIntervals: this.initialZoneTimeIntervals(),
                        nightStart: seasonCalculation.content.nightStart
                            ? moment(seasonCalculation.content.nightStart, 'HH:mm').format('HH:mm')
                            : undefined,
                        nightEnd: seasonCalculation.content.nightEnd
                            ? moment(seasonCalculation.content.nightEnd, 'HH:mm').format('HH:mm')
                            : undefined,
                        driverNightSurcharge: seasonCalculation.content.driverNightSurcharge,
                        company: `${TOMCAT_URL}api/${Entities.BUS_COMPANY.repository}/${selectedCompany}`,
                    };
                } else {
                    initialValues = {
                        seasonSurcharges: [],
                        specialSurcharges: [],
                        sundayDriverSurcharge: 0,
                        holidayDriverSurcharge: 0,
                        nightStart: '23:00',
                        nightEnd: '05:00',
                        driverNightSurcharge: 0,
                        company: `${TOMCAT_URL}api/${Entities.BUS_COMPANY.repository}/${selectedCompany}`,
                    };
                }

                return (
                    <SeasonCalculationEditForm
                        t={t}
                        initialValues={initialValues}
                        onSubmit={this.handleSubmit}
                        seasonCalculation={seasonCalculation.content}
                        tripCompanies={this.props.tripCompanies}
                        selectedCompany={selectedCompany}
                        setSliderIndex={this.props.setSliderIndex}
                        selectedSliderIndex={this.props.selectedSliderIndex}
                        fixedPriceZones={ownCompany.entity.fixedPriceZones}
                        currencySymbol={currencySymbol}
                        ref={ref => (this.childForm = ref)}
                    />
                );
            }
        } else return <CircularProgress />;
    }

    handleSubmit(data) {
        const { handleClose, isCreate, selectedCompany, ownCompany } = this.props;

        this.formatDataForBackend(data, ownCompany);
        if (isCreate) this.props.save(data, Entities.SEASON_CALCULATION, selectedCompany);
        else this.props.patch(data, Entities.SEASON_CALCULATION, selectedCompany);

        handleClose();
    }

    formatHolidaysForForm(holidays) {
        if (!holidays) return undefined;
        else return _.sortBy(holidays.map(holiday => moment(holiday))).map(holiday => holiday.format('DD.MM.YYYY'));
    }

    formatSurchargesForForm(seasonSurcharges) {
        if (!seasonSurcharges) return undefined;
        else {
            return seasonSurcharges.map(seasonSurcharge => {
                return {
                    name: seasonSurcharge.name,
                    surcharge: seasonSurcharge.surcharge,
                    startDate: moment(seasonSurcharge.startDate).format('DD.MM.YYYY'),
                    endDate: moment(seasonSurcharge.endDate).format('DD.MM.YYYY'),
                    minimumRate: seasonSurcharge.minimumRate,
                    tripCompany: seasonSurcharge.tripCompany,
                };
            });
        }
    }

    initialZoneTimeIntervals() {
        const { seasonCalculation } = this.props;

        const zoneTimeIntervals = seasonCalculation.content.zoneTimeIntervals || [];
        Object.keys(DayOfWeek).forEach(day => {
            if (!zoneTimeIntervals[day]) {
                zoneTimeIntervals[day] = {
                    first: null,
                    second: null,
                };
            }

            if (zoneTimeIntervals[day].first == null) zoneTimeIntervals[day].first = { from: null, to: null };

            if (zoneTimeIntervals[day].second == null) zoneTimeIntervals[day].second = { from: null, to: null };

            if (zoneTimeIntervals[day].first) {
                if (zoneTimeIntervals[day].first.from)
                    zoneTimeIntervals[day].first.from = moment(zoneTimeIntervals[day].first.from, 'HH:mm:ss').format(
                        'HH:mm',
                    );
                else zoneTimeIntervals[day].first.to = null;
                if (zoneTimeIntervals[day].first.to)
                    zoneTimeIntervals[day].first.to = moment(zoneTimeIntervals[day].first.to, 'HH:mm:ss').format(
                        'HH:mm',
                    );
                else zoneTimeIntervals[day].first.from = null;
            }

            if (zoneTimeIntervals[day].second) {
                if (zoneTimeIntervals[day].second.from)
                    zoneTimeIntervals[day].second.from = moment(zoneTimeIntervals[day].second.from, 'HH:mm:ss').format(
                        'HH:mm',
                    );
                else zoneTimeIntervals[day].second.to = null;
                if (zoneTimeIntervals[day].second.to)
                    zoneTimeIntervals[day].second.to = moment(zoneTimeIntervals[day].second.to, 'HH:mm:ss').format(
                        'HH:mm',
                    );
                else zoneTimeIntervals[day].second.from = null;
            }
        });
        return zoneTimeIntervals;
    }

    formatDataForBackend(data, ownCompany) {
        setMoneyCurrency(data.mondayRate, ownCompany.entity.currency);
        setMoneyCurrency(data.tuesdayRate, ownCompany.entity.currency);
        setMoneyCurrency(data.wednesdayRate, ownCompany.entity.currency);
        setMoneyCurrency(data.thursdayRate, ownCompany.entity.currency);
        setMoneyCurrency(data.fridayRate, ownCompany.entity.currency);
        setMoneyCurrency(data.saturdayRate, ownCompany.entity.currency);
        setMoneyCurrency(data.sundayRate, ownCompany.entity.currency);

        if (data.seasonSurcharges) {
            data.seasonSurcharges = data.seasonSurcharges.map(seasonSurcharge => {
                const tripCompany = this.props.tripCompanies.find(tripCompany =>
                    typeof seasonSurcharge.tripCompany === 'string'
                        ? tripCompany.companyName === seasonSurcharge.tripCompany
                        : seasonSurcharge.tripCompany != null && tripCompany.id === seasonSurcharge.tripCompany.id,
                );
                const tripCompanyUrl = tripCompany
                    ? `${TOMCAT_URL}api/${Entities.TRIP_COMPANY.repository}/${tripCompany.id}`
                    : null;
                return {
                    name: seasonSurcharge.name,
                    surcharge: seasonSurcharge.surcharge,
                    startDate: moment(seasonSurcharge.startDate, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                    endDate: moment(seasonSurcharge.endDate, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                    minimumRate: seasonSurcharge.minimumRate,
                    tripCompany: tripCompanyUrl,
                };
            });
        }
        if (data.specialSurcharges) {
            data.specialSurcharges = data.specialSurcharges.map(specialSurcharge => {
                return {
                    name: specialSurcharge.name,
                    surcharge: specialSurcharge.surcharge,
                    startDate: moment(specialSurcharge.startDate, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                    endDate: moment(specialSurcharge.endDate, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                };
            });
        }
        if (data.holidays) {
            data.holidays = data.holidays
                .filter(holiday => typeof holiday === 'string' && holiday.length > 0)
                .map(holiday => moment(holiday, 'DD.MM.YYYY').format('YYYY-MM-DD'));
        }

        if (data.zones)
            Object.keys(data.zones).forEach(key => {
                setMoneyCurrency(data.zones[key].price, ownCompany.entity.currency);
            });

        if (data.zoneTimeIntervals)
            Object.keys(data.zoneTimeIntervals).forEach(day => {
                if (data.zoneTimeIntervals[day]) {
                    // remove time interval first property if contained values are null
                    // otherwise make sure the format is HH:mm and not H:mm (moment is smart enough to parse 8:00 with HH:mm, but Jackson isn't)
                    if (data.zoneTimeIntervals[day].first) {
                        const first = data.zoneTimeIntervals[day].first;
                        if (!first.from || !first.to) data.zoneTimeIntervals[day].first = null;
                        else {
                            data.zoneTimeIntervals[day].first.from = moment(
                                data.zoneTimeIntervals[day].first.from,
                                'HH:mm',
                            ).format('HH:mm');
                            data.zoneTimeIntervals[day].first.to = moment(
                                data.zoneTimeIntervals[day].first.to,
                                'HH:mm',
                            ).format('HH:mm');
                        }
                    }

                    // remove time interval second property if contained values are null
                    // otherwise make sure the format is HH:mm and not H:mm (moment is smart enough to parse 8:00 with HH:mm, but Jackson isn't)
                    if (data.zoneTimeIntervals[day].second) {
                        const second = data.zoneTimeIntervals[day].second;
                        if (!second.from || !second.to) data.zoneTimeIntervals[day].second = null;
                        else {
                            data.zoneTimeIntervals[day].second.from = moment(
                                data.zoneTimeIntervals[day].second.from,
                                'HH:mm',
                            ).format('HH:mm');
                            data.zoneTimeIntervals[day].second.to = moment(
                                data.zoneTimeIntervals[day].second.to,
                                'HH:mm',
                            ).format('HH:mm');
                        }
                    }

                    // remove whole day if first and second opening hours are empty
                    if (data.zoneTimeIntervals[day].first == null && data.zoneTimeIntervals[day].second == null)
                        data.zoneTimeIntervals[day] = null;
                }
            });

        data.nightStart = moment(data.nightStart, 'HH:mm').format('HH:mm');
        data.nightEnd = moment(data.nightEnd, 'HH:mm').format('HH:mm');
    }
}

const mapStateToProps = state => {
    return {
        seasonCalculation: getUpdatedEntity(state, Entities.SEASON_CALCULATION, state.selectedCompany),
        selectedCompany: state.selectedCompany,
        selectedSliderIndex: state.selectedSliderIndex,
        ownCompany: getOwnCompany(state),
    };
};

export default connect(mapStateToProps, { fetchById, patch, save, setSliderIndex }, null, { withRef: true })(
    SeasonCalculationEditModal,
);
